import {mapActions, mapGetters} from 'vuex'

export const renderMixin = {
  computed: {
    ...mapGetters({
      'renderQueues': 'render/renderQueues',
      'renderBatches': 'render/renderBatches',
      'renderStats': 'render/renderStats',
      'renderCapacity': 'render/renderCapacity'
    })
  },
  methods: {
    ...mapActions({
      'getRenderQueues': 'render/getRenderQueues',
      'getRenderBatches': 'render/getRenderBatches',
      'deleteRenderBatch': 'render/deleteRenderBatch',
      'updateRenderQueue': 'render/updateRenderQueue',
      'deleteRenderQueue': 'render/deleteRenderQueue',
      'updateRenderQueueBatchWise': 'render/updateRenderQueueBatchWise',
      'deleteRenderBot': 'render/deleteRenderBot'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/renderMixin.js